import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { userLst } from 'src/app/models/userLst';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { CreateEditDeportistaComponent } from '../create-edit-deportista/create-edit-deportista.component';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { ModalQrComponent } from '../../varios/modal-qr/modal-qr.component';
import { EditDetalleUsuariosComponent } from '../edit-detalle-usuarios/edit-detalle-usuarios.component';
import { HistorialIngresosUsuarioComponent } from '../historial-ingresos-usuario/historial-ingresos-usuario.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ExtencionService } from 'src/app/services/extencion.service';

@Component({
  selector: 'app-index-deportistas-eliminados',
  templateUrl: './index-deportistas-eliminados.component.html',
  styleUrl: './index-deportistas-eliminados.component.scss',
})
export class IndexDeportistasEliminadosComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  permiteExtencion = false;
  searchString: string = '';
  public lstDisciplinas: any;
  public lstPlanes: any;
  public lstDeportistas: userLst[];
  public disciplinaSelect: any;
  public ordenamientoSelect = '0';
  public hoy = new Date();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public userSvc: UserService,
    public disciplinaSvc: DisciplinaService,

    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: userLst[] = [];
    this.displayedColumns = [
      'nombre', 
      'fechaFin',
      'botones',
    ];

    this.dataSource = new MatTableDataSource<userLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getUsers(0, 10);
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getUsers(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.userSvc
      .getDeportistasEliminados(
        page,
        numReg,
        this.searchString,
        this.ordenamientoSelect,
        this.disciplinaSelect
      )
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<userLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.lstDeportistas = result[0];
        this.isLoadingResults = false;

        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getUsers(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getUsers(0, 10);
  }

  activar(obj: any) {
    console.log(obj);
    this.alertify.confirm('Confirma que quiere activar el deportista?', () => {
      this.userSvc.ReactivarUsuario(obj).subscribe((res) => {
        if (res) {
          this.getUsers(this.pageIndex, this.pageSize);
          this.alertify.success('Deportista activado correctamente.');
        } else {
          this.alertify.error('El deportista no se ha podido activar, intentelo nuevamente.');
        }
      });
    });
  }
}
